"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _helpers = require("./helpers");

var _parseMask = _interopRequireDefault(require("./parse-mask"));

/* eslint no-use-before-define: ["error", { functions: false }] */
var MaskUtils = /*#__PURE__*/(0, _createClass2.default)(function MaskUtils(options) {
  var _this = this;

  (0, _classCallCheck2.default)(this, MaskUtils);
  (0, _defineProperty2.default)(this, "maskOptions", void 0);
  (0, _defineProperty2.default)(this, "isCharacterAllowedAtPosition", function (character, position) {
    var maskPlaceholder = _this.maskOptions.maskPlaceholder;

    if (_this.isCharacterFillingPosition(character, position)) {
      return true;
    }

    if (!maskPlaceholder) {
      return false;
    }

    return maskPlaceholder[position] === character;
  });
  (0, _defineProperty2.default)(this, "isCharacterEqualsMaskPlaceholder", function (character, position) {
    var maskPlaceholder = _this.maskOptions.maskPlaceholder;

    if (!character || !maskPlaceholder) {
      return false;
    }

    return maskPlaceholder[position] === character;
  });
  (0, _defineProperty2.default)(this, "isCharacterFillingPosition", function (character, position) {
    var mask = _this.maskOptions.mask;

    if (!character || !mask || position >= mask.length) {
      return false;
    }

    var charRule = mask[position];

    if (!_this.isPositionEditable(position)) {
      return charRule === character;
    }

    return new RegExp(charRule).test(character);
  });
  (0, _defineProperty2.default)(this, "isPositionEditable", function (position) {
    var _this$maskOptions = _this.maskOptions,
        mask = _this$maskOptions.mask,
        permanents = _this$maskOptions.permanents;
    return !!mask && position < mask.length && permanents.indexOf(position) === -1;
  });
  (0, _defineProperty2.default)(this, "isValueEmpty", function (value) {
    var characters = value.split('');
    return characters.every(function (character, position) {
      return !_this.isPositionEditable(position) || _this.isCharacterEqualsMaskPlaceholder(character, position) || !_this.isCharacterFillingPosition(character, position);
    });
  });
  (0, _defineProperty2.default)(this, "isValueFilled", function (value) {
    return _this.maskOptions.lastEditablePosition != null && _this.getFilledLength(value) === _this.maskOptions.lastEditablePosition + 1;
  });
  (0, _defineProperty2.default)(this, "getDefaultSelectionForValue", function (value) {
    var filledLength = _this.getFilledLength(value);

    var cursorPosition = _this.getRightEditablePosition(filledLength);

    return {
      start: cursorPosition,
      end: cursorPosition,
      length: 0
    };
  });
  (0, _defineProperty2.default)(this, "getFilledLength", function (value) {
    var characters = value.split('');
    var lastFilledIndex = (0, _helpers.findLastIndex)(characters, function (character, position) {
      return _this.isPositionEditable(position) && _this.isCharacterFillingPosition(character, position);
    });
    return lastFilledIndex + 1;
  });
  (0, _defineProperty2.default)(this, "getStringFillingLengthAtPosition", function (string, position) {
    var characters = string.split('');
    var insertedValue = characters.reduce(function (value, character) {
      return _this.insertCharacterAtPosition(value, character, value.length);
    }, (0, _helpers.repeat)(' ', position));
    return insertedValue.length - position;
  });
  (0, _defineProperty2.default)(this, "getLeftEditablePosition", function (position) {
    for (var i = position; i >= 0; i--) {
      if (_this.isPositionEditable(i)) {
        return i;
      }
    }

    return 0;
  });
  (0, _defineProperty2.default)(this, "getRightEditablePosition", function (position) {
    var mask = _this.maskOptions.mask;

    if (!mask) {
      return 0;
    }

    for (var i = position; i < mask.length; i++) {
      if (_this.isPositionEditable(i)) {
        return i;
      }
    }

    return 0;
  });
  (0, _defineProperty2.default)(this, "formatValue", function (value) {
    var _this$maskOptions2 = _this.maskOptions,
        maskPlaceholder = _this$maskOptions2.maskPlaceholder,
        mask = _this$maskOptions2.mask;

    if (!maskPlaceholder) {
      value = _this.insertStringAtPosition('', value, 0);

      while (value.length < mask.length && !_this.isPositionEditable(value.length)) {
        value += mask[value.length];
      }

      return value;
    }

    return _this.insertStringAtPosition(maskPlaceholder, value, 0);
  });
  (0, _defineProperty2.default)(this, "clearRange", function (value, start, len) {
    if (!len || start == null) {
      return value;
    }

    var end = start + len;
    var _this$maskOptions3 = _this.maskOptions,
        maskPlaceholder = _this$maskOptions3.maskPlaceholder,
        mask = _this$maskOptions3.mask;
    var clearedValue = value.split('').map(function (character, i) {
      var isEditable = _this.isPositionEditable(i);

      if (!maskPlaceholder && i >= end && !isEditable) {
        return '';
      }

      if (i < start || i >= end) {
        return character;
      }

      if (!isEditable) {
        return mask[i];
      }

      if (maskPlaceholder) {
        return maskPlaceholder[i];
      }

      return '';
    }).join('');
    return _this.formatValue(clearedValue);
  });
  (0, _defineProperty2.default)(this, "insertCharacterAtPosition", function (value, character, position) {
    var _this$maskOptions4 = _this.maskOptions,
        mask = _this$maskOptions4.mask,
        maskPlaceholder = _this$maskOptions4.maskPlaceholder;

    if (position >= mask.length) {
      return value;
    }

    var isAllowed = _this.isCharacterAllowedAtPosition(character, position);

    var isEditable = _this.isPositionEditable(position);

    var nextEditablePosition = _this.getRightEditablePosition(position);

    var isNextPlaceholder = maskPlaceholder && nextEditablePosition ? character === maskPlaceholder[nextEditablePosition] : null;
    var valueBefore = value.slice(0, position);

    if (isAllowed || !isEditable) {
      var insertedCharacter = isAllowed ? character : mask[position];
      value = valueBefore + insertedCharacter;
    }

    if (!isAllowed && !isEditable && !isNextPlaceholder) {
      value = _this.insertCharacterAtPosition(value, character, position + 1);
    }

    return value;
  });
  (0, _defineProperty2.default)(this, "insertStringAtPosition", function (value, string, position) {
    var _this$maskOptions5 = _this.maskOptions,
        mask = _this$maskOptions5.mask,
        maskPlaceholder = _this$maskOptions5.maskPlaceholder;

    if (!string || position == null || position >= mask.length) {
      return value;
    }

    var characters = string.split('');
    var isFixedLength = _this.isValueFilled(value) || !!maskPlaceholder;
    var valueAfter = value.slice(position);
    value = characters.reduce(function (value, character) {
      return _this.insertCharacterAtPosition(value, character, value.length);
    }, value.slice(0, position));

    if (isFixedLength) {
      value += valueAfter.slice(value.length - position);
    } else if (_this.isValueFilled(value)) {
      // @ts-ignore
      value += mask.slice(value.length).join('');
    } else {
      var editableCharactersAfter = valueAfter.split('').filter(function (character, i) {
        return _this.isPositionEditable(position + i);
      });
      value = editableCharactersAfter.reduce(function (value, character) {
        var nextEditablePosition = _this.getRightEditablePosition(value.length);

        if (nextEditablePosition === null) {
          return value;
        }

        if (!_this.isPositionEditable(value.length)) {
          // @ts-ignore
          value += mask.slice(value.length, nextEditablePosition).join('');
        }

        return _this.insertCharacterAtPosition(value, character, value.length);
      }, value);
    }

    return value;
  });
  (0, _defineProperty2.default)(this, "processChange", function (currentState, previousState) {
    var _this$maskOptions6 = _this.maskOptions,
        mask = _this$maskOptions6.mask,
        prefix = _this$maskOptions6.prefix,
        lastEditablePosition = _this$maskOptions6.lastEditablePosition;
    var value = currentState.value,
        selection = currentState.selection;
    var previousValue = previousState.value;
    var previousSelection = previousState.selection;
    var newValue = value;
    var enteredString = '';
    var formattedEnteredStringLength = 0;
    var removedLength = 0;
    var cursorPosition = Math.min(previousSelection.start, selection.start);

    if (selection.end > previousSelection.start) {
      enteredString = newValue.slice(previousSelection.start, selection.end);
      formattedEnteredStringLength = _this.getStringFillingLengthAtPosition(enteredString, cursorPosition);

      if (!formattedEnteredStringLength) {
        removedLength = 0;
      } else {
        removedLength = previousSelection.length;
      }
    } else if (newValue.length < previousValue.length) {
      removedLength = previousValue.length - newValue.length;
    }

    newValue = previousValue;

    if (removedLength) {
      if (removedLength === 1 && !previousSelection.length) {
        var deleteFromRight = previousSelection.start === selection.start;
        cursorPosition = deleteFromRight ? _this.getRightEditablePosition(selection.start) : _this.getLeftEditablePosition(selection.start);
      }

      newValue = _this.clearRange(newValue, cursorPosition, removedLength);
    }

    newValue = _this.insertStringAtPosition(newValue, enteredString, cursorPosition);

    if (cursorPosition != null) {
      cursorPosition += formattedEnteredStringLength;

      if (cursorPosition >= mask.length) {
        cursorPosition = mask.length;
      } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
        cursorPosition = prefix.length;
      } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
        cursorPosition = _this.getRightEditablePosition(cursorPosition);
      }
    }

    newValue = _this.formatValue(newValue);
    return {
      value: newValue,
      selection: {
        start: cursorPosition,
        end: cursorPosition,
        length: 0
      }
    };
  });
  this.maskOptions = (0, _parseMask.default)(options);
});
exports.default = MaskUtils;